import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import CrmMember from "../../components/crmMember";
import CrmSystem from "../../components/crmSystem";
import CrmKTP from "../../components/crmKTP";
import CrmTambahan from "../../components/crmTambahan";
import Api from "../../../../../Services/Api";
import * as R from "ramda";
import {mapToObjectDDL, mapToSelectOption, removeNullFields} from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {ACTIVITY_TYPE} from "../../../../common/Constants";
import {
    loyaltyLevelOptions,
    memberLevelOptions,
    prospekCategoryOptions,
    prospekSourceOptions,
    prospekTypeOptions, specialCategoryOptions
} from "../../config/constants";
import FollowUpHistoryExpandable from "./followUpHistoryExpandable";
import {fetchDataAsync} from "../../../../../Services/Utils";

class CRMFollowUpHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            options: {
                provinceOptions: [],
                kabkotOptions: [],
                kecamatanOptions: [],
                kelurahanOptions: [],
                zipCodeOptions: [],
                zipCodeRaw: [],
                genderOptions: [],
                religionOptions: [],
                jobOptions: [],
                hobbyOptions: [],
                interestOptions: [],
                prospekSourceCreateOptions: [],
                prospekCategoryOptions,
                prospekSourceOptions,
                prospekTypeOptions,
                memberLevelOptions,
                loyaltyLevelOptions,
                specialCategoryOptions,
            },
        };
    };

    componentDidMount() {
        if (!R.isNil(this.props.initialValues)) {
        }

        this.setDataOptions("prospekSourceCreateOptions", prospekSourceOptions.slice(1));

        this.fetchDataProvince();
        this.fetchBizpar();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.controls?.provinceId?.value?.value !== this.props.controls.provinceId?.value?.value) {
            this.setDataOptions("kabkotOptions", []);
            this.setDataOptions("kecamatanOptions", []);
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            this.props.setValue("kabkotId", null);
            this.props.setValue("kecamatanId", null);
            this.props.setValue("kelurahanId", null);
            this.props.setValue("zipcode", null);
            this.fetchDataKabKot(this.props.controls.provinceId?.value?.value);
        }
        if (prevProps.controls?.kabkotId?.value?.value !== this.props.controls.kabkotId?.value?.value) {
            console.log("here")
            this.setDataOptions("kecamatanOptions", []);
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            this.props.setValue("kecamatanId", null);
            this.props.setValue("kelurahanId", null);
            this.props.setValue("zipcode", null);
            this.fetchDataKecamatan(this.props.controls.kabkotId?.value?.value);
        }
        if (prevProps.controls?.kecamatanId?.value?.value !== this.props.controls.kecamatanId?.value?.value) {
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            this.props.setValue("kelurahanId", null);
            this.props.setValue("zipcode", null);
            this.fetchDataKelurahan(this.props.controls.kecamatanId?.value?.value);
        }
        if (prevProps.controls?.kelurahanId?.value?.value !== this.props.controls.kelurahanId?.value?.value && !R.isEmpty(this.state.options.zipCodeRaw)) {
            const data = this.state.options.zipCodeRaw.find(item => item.id === this.props.controls.kelurahanId?.value?.value);
            this.setDataOptions("zipCodeOptions", !R.isEmpty(data) ? [mapToObjectDDL(data.zipcode, data.zipcode)] : []);
        }
    };

    fetchDataProvince = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("provinceOptions", response.data.data.map(item => mapToObjectDDL(item.provinceName, item.id)));

            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKabKot = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kabkotOptions", response.data.data.map(item => mapToObjectDDL(item.kabKotName, item.kabKotId)));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKecamatan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kecamatanOptions", response.data.data.map(item => mapToObjectDDL(item.kecamatanName, item.id)));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKelurahan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kelurahanOptions", response.data.data.map(item => mapToObjectDDL(item.kelurahanname, item.id)));
                this.setDataOptions("zipCodeRaw", response.data.data);
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchBizpar = async () => {
        this.props.triggerLoading();
        const menuName = "CRM - Follow Up Prospect";
        const responses = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                setError: this.props.setError,
                menuName: menuName,
                args: {paramFilters: {bizparCategory: "GENDER_TYPE"}}
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                setError: this.props.setError,
                menuName: menuName,
                args: {paramFilters: {bizparCategory: "RELIGION_TYPE"}}
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                setError: this.props.setError,
                menuName: menuName,
                args: {paramFilters: {bizparCategory: "JOB_TYPE"}}
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                setError: this.props.setError,
                menuName: menuName,
                args: {paramFilters: {bizparCategory: "HOBBY_TYPE"}}
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                setError: this.props.setError,
                menuName: menuName,
                args: {paramFilters: {bizparCategory: "INTEREST_TYPE"}}
            }),
        ]);
        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setDataOptions("genderOptions", responses[0].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.setDataOptions("religionOptions", responses[1].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
        if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
            this.setDataOptions("jobOptions", responses[2].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
        if (responses[3].ok && !R.isEmpty(responses[3].data.data)) {
            this.setDataOptions("hobbyOptions", responses[3].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
        if (responses[4].ok && !R.isEmpty(responses[4].data.data)) {
            this.setDataOptions("interestOptions", responses[4].data.data.map(item => mapToObjectDDL(item.value, item.key)));
        }
        this.props.triggerLoading();
    };

    handleCheckNIK = async () => {
        this.props.triggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").checkNIKForFU,
            menuName: "CRM - Follow Up Prospect",
            setError: this.props.setError,
            args: this.props.controls.nik.value,
        });
        if (res.ok && !R.isNil(res.data.data)) {
            let data = res.data.data;
            this.props.setValue("name", data.nama);
            this.props.setValue("nik", data.nik);
            this.props.setValue("address", data.alamat);
            this.props.setValue("provinceId", mapToObjectDDL(data.province.provinceName, data.province.id));
            this.props.setValue("kabkotId", mapToObjectDDL(data.kabkot.kabKotName, data.kabkot.kabKotId));
            this.props.setValue("kecamatanId", mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id));
            this.props.setValue("kelurahanId", mapToObjectDDL(data.kelurahan.kelurahanname, data.kelurahan.id));
            this.props.setValue("zipcode", mapToObjectDDL(data.kodePos, data.kodePos));
            this.props.setValue("gender", mapToObjectDDL(data.jenisKelamin.value, data.jenisKelamin.key));
            this.props.setValue("job1", mapToObjectDDL(data.pekerjaan1.value, data.pekerjaan1.key));
            this.props.setValue("job2", R.isNil(data.pekerjaan2) ? null : mapToObjectDDL(data?.pekerjaan2?.value, data?.pekerjaan2?.key));
            this.props.setValue("religion", mapToObjectDDL(data.agama.value, data.agama.key));
            this.props.setValue("hpNumber1", data?.prospect?.hpNumber1);
            this.props.setValue("hpNumber2", data?.prospect?.hpNumber2);
            this.props.setValue("email", data?.prospect?.email);
            this.props.setValue("facebook", data?.prospect?.facebook);
            this.props.setValue("instagram", data?.prospect?.instagram);
            this.props.setValue("linkedin", data?.prospect?.linkedin);
            this.props.setValue("twitter", data?.prospect?.x);
            this.props.setValue("tiktok", data?.prospect?.tiktok);
            this.props.setValue("discCategory", R.isNil(data?.prospect?.discountCategory) ? null : mapToSelectOption(data?.prospect?.discountCategory));
            this.props.setValue("hobby", data?.prospect?.hobby?.map(item => mapToObjectDDL(item.value, item.key)));
            this.props.setValue("interest", data?.prospect?.interest?.map(item => mapToObjectDDL(item.value, item.key)));
            this.props.setValue("customerId", data?.prospect?.member?.customerId);
            this.props.setValue("memberLevel", data?.prospect?.member?.memberLevel ? mapToSelectOption(data?.prospect?.member?.memberLevel) : null);
            this.props.setValue("loyaltyLevel", data?.prospect?.member?.loyaltyMember ? mapToSelectOption(data?.prospect?.member?.loyaltyMember) : null);
            this.props.setValue("specialNotes", data?.prospect?.member?.specialNotes);
            this.props.setValue("photoCustomerUrl", data?.prospect?.member?.photoCustomerUrl);
            this.props.setValue("prospectId", data?.prospectId);
            this.props.setValue("kodeCabang", data?.kodeCabang?.kodeCabang);
            this.props.setValue("prospectDate", data?.prospectDate);
            this.props.setValue("category", prospekCategoryOptions.find(item => item.value === data?.prospect?.prospectCategory));
            this.props.setValue("source", prospekSourceOptions.find(item => item.value === data?.prospect?.prospectSource));
            this.props.setValue("type", prospekTypeOptions.find(item => item.value === data?.prospect?.type));
            this.props.setValue("lastFollowUpBy", data?.prospect?.lastUpdateByUser?.name);
            this.props.setValue("prospectOwnership", data?.prospect?.userProspectOwner?.name);
            this.props.setValue("lastSeller", data?.prospect?.userLastSeller?.name);
        }
        this.props.triggerLoading();
    };

    setDataOptions = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            options: {
                ...prevValue.options,
                [name]: value,
            },
        }));
    };

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onRefresh();
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title={this.props.title}
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <Tabs>
                            <TabList>
                                <Tab>Data KTP</Tab>
                                <Tab>Data Tambahan</Tab>
                                <Tab>Data Member</Tab>
                                <Tab>Data Sistem</Tab>
                            </TabList>
                            <TabPanel>
                                <CrmKTP {...this.props} options={this.state.options}
                                        onClickCheck={this.handleCheckNIK}/>
                            </TabPanel>
                            <TabPanel>
                                <CrmTambahan {...this.props} options={this.state.options}/>
                            </TabPanel>
                            <TabPanel>
                                <CrmMember {...this.props} options={this.state.options}/>
                            </TabPanel>
                            <TabPanel>
                                <CrmSystem {...this.props} options={this.state.options} box="FU"/>
                            </TabPanel>
                        </Tabs>
                        {this.props.activityType === ACTIVITY_TYPE.CREATE && (
                            <FlexView style={{justifyContent: "end", marginTop: "20px"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </FlexView>
                        )}
                        {(this.props.activityType === ACTIVITY_TYPE.VIEW || this.props.activityType === ACTIVITY_TYPE.DELETE) && (
                            <FollowUpHistoryExpandable
                                {...this.props}
                            />
                        )}
                        {((this.props.tab === "ONGOING" || this.props.tab === "PENDING") && this.props.activityType === ACTIVITY_TYPE.DELETE) && (
                            <FlexView style={{justifyContent: "end"}}>
                                <SimpleButton
                                    onClick={() => this.props.onDeleteProspect(this.props.initialValues.prospectId)}
                                >DELETE</SimpleButton>
                            </FlexView>
                        )}
                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(CRMFollowUpHistory);